//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import { BailetsBlock } from '../../ModalCopy.styles';
import { CloseVideoIcon, LogoMartins } from '@assets/svgs';
import JackWhite from '@assets/JackWhite.jpeg';
import SarahMcCarthy from '@assets/SarahMcCarthy.jpeg';

type EmailsProps = {
  showImg?: boolean | string;
  showMedia?: boolean | string;
};

type Events = {
  isClosed?: () => void;
};

const EmailsHead = ({ showImg, showMedia }: EmailsProps) => {
  return (
    <>
      <LogoMartins
        width={70}
        height={65}
        color="rgba(0,0,0,0.5)"
        animation="mansion"
      />

      <h3>EMAIL MARKETING</h3>
      <span style={{ marginBottom: '25px' }}>EMAILS COLLECTIONS</span>
    </>
  );
};

export const Emails = ({ isClosed }: Events) => {
  return (
    <>
      <BailetsBlock>
        <CloseVideoIcon
          animation="closeIcon"
          color="#000"
          isActive={isClosed}
        />
        <EmailsHead />
        <h3
          style={{
            marginTop: '25px',
            textAlign: 'left',
            paddingLeft: '35px',
            paddingRight: '35px',
            boxSizing: 'border-box'
          }}
        >
          Employers dived into a stupid world?
        </h3>
        <p style={{ width: '100%' }}>
          <span>By George Martin's</span>
        </p>
        <br />
        <p style={{ width: '100%' }}>
          {
            '{%name%}, last week, a friend of mine had an incredible opportunity to learn and grow in her role. Unfortunately, it ended after only a month.'
          }
        </p>
        <p style={{ width: '100%' }}>
          It's not fair, especially for a single mother with two young children,
          aged four and six. For someone with limited options, this situation
          poses a significant challenge—but it can be navigated! That job
          represented a fresh start for her, fueling her motivation and
          aspirations.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          She's left wondering why this happened, but I'm sure she'll get
          another job soon!
        </p>
        <br />
        <p style={{ width: '100%' }}>
          But why is this the case? Because many companies overlook the value of
          their employees. To them, their workers often seem invisible.
          Employers seem to be trapped in a cycle of ignorance, which has become
          their new normal.
        </p>
        <br />
        <p style={{ width: '100%', marginTop: '10px' }}>
          It's about time things changed!{' '}
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          It's time to shake up this cycle of indifference and show some
          respect!{' '}
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>It's heartbreaking!</p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          It's a real eye-opener!
        </p>
        <p style={{ width: '100%' }}>
          I'm thrilled to announce that she's now part of my team as a writer.{' '}
        </p>
        <p style={{ width: '100%' }}>
          Working with skilled professionals like her is an absolute joy.
        </p>
        <p style={{ width: '100%' }}>Her passion shines through.</p>
        <p style={{ width: '100%' }}>
          Her passion is contagious, and it's inspiring to see the remarkable
          life stories she brings to the table. Yours could be next!
        </p>
        <p style={{ width: '100%' }}>
          So be patient, invest in your employees, and watch your success story
          unfold!
        </p>
        <p style={{ width: '100%' }}>
          So, go on, support them! They need a stable income, just as you do.
        </p>
        <br />
        <p style={{ width: '100%' }}>- George Martin’s</p>
        <p style={{ width: '100%' }}>
          P.S. Don’t do to others what you don’t want others to do to you.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Put yourself in my friend’s shoes, and think about it.
        </p>
      </BailetsBlock>
      <BailetsBlock>
        <h3
          style={{
            marginTop: '25px',
            textAlign: 'left',
            paddingLeft: '35px',
            paddingRight: '35px',
            boxSizing: 'border-box'
          }}
        >
          I hired two writers to work with me. Meet Jack W. White and J. E.
          Robin.
        </h3>
        <p style={{ width: '100%' }}>
          <span>By George Martin's</span>
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>We are</b> Writers
        </p>
        <br />
        <p style={{ width: '100%' }}>{'{%name%},'}</p>
        <p style={{ width: '100%' }}>
          The most iconic gift that anyone can possess is the ability to
          manipulate profound stories in a fluid imagination and translate them
          to their audience wrapped obsessively and impulsively.
        </p>
        <p style={{ width: '100%' }}>… that’s deep, entirely!</p>
        <p style={{ width: '100%' }}>
          Yes - being a writer is also the most blessed talent anyone can enjoy.{' '}
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          You can recreate the whole universe with your totality. And even
          reevent your soul, redesign the time and reshape the existence.
        </p>
        <p style={{ width: '100%' }}>To be honest,</p>
        <p style={{ width: '100%' }}>
          the whole creation, including us, was written by a Supreme writer. He
          wrote the destiny of everything in the Book of LIFE. The steps we give
          each day. The words we speak and the uncounted thoughts we generate
          every second of our existence.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Believe it or not, no one can change a word written by the KING of
          Kings.
        </p>
        <p style={{ width: '100%' }}>
          That's one reason I think being an author is the most powerful gift
          anyone can experience.
        </p>
        <p style={{ width: '100%' }}>So, as a writer,</p>
        <p style={{ width: '100%' }}>
          … I decided to establish new human beings with gifts and give them
          lives that would transform the way our planet performs.
        </p>
        <p style={{ width: '100%' }}>
          I have had the idea of developing two personas.
        </p>
        <p style={{ width: '100%' }}>
          I work with two writers. They are virtual characters, the result of my
          thoughts, and I am their ghostwriter.{' '}
        </p>
        <p style={{ width: '100%' }}>Jack W. White & J. E. Robin.</p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          They were born writers. Everything they write comes true and what they
          touch blooms. Every word written becomes gold…
        </p>
        <p style={{ width: '100%' }}>The beginning… 04:12 am</p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          I started working on the story of their lives.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          They meet in Manhattan.
        </p>
        <p style={{ width: '100%' }}>Jack gives the first words…</p>
        <p style={{ width: '100%' }}>
          "Hey, I'm Jack W. White, 42, and I'm a fiction author! I'm also a
          technical writer and copywriter! I'm an American living the dream in
          New York!”
        </p>
        <br />
        <Image
          src={JackWhite}
          width={1024}
          height={1456}
          alt="Jack W. White"
          style={{
            paddingLeft: '20px',
            paddingRight: '20px',
            boxSizing: 'border-box'
          }}
        />
        <p style={{ width: '100%' }}>
          He is intelligent and very talented. I will help him to write amazing
          copy for George Martin’s clients.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          His work is amazing! It's like magic and the final results are always
          incredible. He has a superior attitude, which is not so much gentle as
          it is confident and assured. He's not one to let go of the struggles
          of his past easily!
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Sarah is just a good British friend…
        </p>
        <p style={{ width: '100%' }}>She presents herself…</p>
        <p style={{ width: '100%' }}>
          "Hi, I'm Sarah Giovanna McCarthy, 37, and I'm a novelist, copywriter
          and fashion writer! I'm a proud Brit living in the incredible city of
          London! Guess what! I'm in New York today, writing a novel with my
          gorgeous friend Jack White.”
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          My pen name… J. E. Robin.
        </p>
        <br />
        <Image
          src={SarahMcCarthy}
          width={1023}
          height={1526}
          alt="Jack W. White"
          style={{
            paddingLeft: '20px',
            paddingRight: '20px',
            boxSizing: 'border-box'
          }}
        />
        <p style={{ width: '100%' }}>
          She’s… incredible and beautiful. She’s humble and shows off a relaxed
          attitude.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Privacy is her shelter, and she's not letting anyone in unless someone
          she admires so much comes along and gives her a knock.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Secretly she admires Jack…
        </p>
        <p style={{ width: '100%' }}>To be continued…</p>
        <br />
        <p style={{ width: '100%' }}>- George Martin’s</p>
        <p style={{ width: '100%' }}>
          P. S. I think something is going on between these two! I just created
          them, and I'm so excited to see what will happen in Manhattan 🙂. And
          maybe in London as well.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          This is a writer’s life, that I love it and it’s so nice to provide
          wonderful stories to my audience.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          You can be one of our writers and show off your talent! Write to us.
          Let’s talk!
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h3
          style={{
            marginTop: '25px',
            textAlign: 'left',
            paddingLeft: '35px',
            paddingRight: '35px',
            boxSizing: 'border-box'
          }}
        >
          Robin & White. Everything started when… Chapter 1
        </h3>
        <p style={{ width: '100%' }}>
          <span>By George Martin's</span>
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>We are</b> Writers
        </p>
        <br />
        <p style={{ width: '100%' }}>06:20 AM</p>
        <p style={{ width: '100%', color: '#000' }}>
          <b>…Beyond Manhattan.</b>
        </p>
        <p style={{ width: '100%' }}>{'{%name%}'}</p>
        <p style={{ width: '100%' }}>
          I had in mind something else, but it'll do!
        </p>
        <p style={{ width: '100%' }}>But…</p>
        <p style={{ width: '100%' }}>
          I’ll write the story of those two wonderful creations of my
          imagination.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          I will think of a new title later. I will type the magic words for Mrs
          Robin and Mr White.{' '}
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          These two magnificent writers will undoubtedly change how the world
          thinks about this concept – it will be amazing!
        </p>
        <p style={{ width: '100%' }}>The excitement was at a high LEVEL.</p>
        <p style={{ width: '100%' }}>
          To create a new existence is beyond words… beyond time, sometimes. At
          those moments time doesn’t exist. Doesn’t run. It’s moonlight till the
          end of the story.
        </p>
        <p style={{ width: '100%' }}>07:35 am…</p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          time for my breakfast with a refreshing coffee.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          I drank it slowly, letting the entire first chapter dance inside my
          brain.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          As I told you in my last email, Jack W. White and J. E. Robin's
          characters were already written down. I presented them to you if you
          can remember them.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          They are the main focus of the story,
        </p>
        <p style={{ width: '100%' }}>So, I had a point to start…</p>
        <br />
        <p style={{ width: '100%', color: '#000' }}>
          <b>CHAPTER 1</b>
        </p>
        <p style={{ width: '100%' }}>07:00 AM</p>
        <p style={{ width: '100%', marginTop: '10px', fontStyle: 'italic' }}>
          “Nothing is more rewarding than the feeling I get when I gaze out at
          the city in the morning from the expansive windows that encase my
          bedroom on the 50th floor. Sitting on my bed, I think, taking in the
          breathtaking view outside. There’s something about magical in
          Manhattan—how the sun fights its way through skyscrapers like an
          artist spilling gold onto canvas.
          <br />
          <br /> We can almost hear the hum of ambition rising with the steam
          from a thousand coffee cups. It’s intoxicating! The sense that
          anything can happen. The feeling I carried with me the morning I met
          Jack White…”
        </p>
        <p style={{ width: '100%' }}>
          ...this could be a good start for the story.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Eventually, I realised that this brief paragraph would serve as the
          ideal starting point for their tale! I paused for a flash, sprang from
          my seat, and was immediately whisked away on an astonishing journey
          through my imagination! Each action and gesture of these remarkable
          writers felt like a fragment of a colossal puzzle slowly falling into
          place!
        </p>
        <p style={{ width: '100%' }}>
          I enjoyed a delightful conversation with them, and they were
          incredibly gracious in engaging with me too.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Moreover, they represent the essence of my travels within my
          imagination. It’s like talking to myself involved with multiple
          personalities.
        </p>
        <p style={{ width: '100%' }}>04:12 PM</p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          I finished the CHAPTER 1
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Finally, they met in the Quill Room, the writer's lounge in Manhattan.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          In a most peculiar turn of events, Jack felt compelled to share a
          closely guarded secret with Robin.
        </p>
        <p style={{ width: '100%' }}>
          Amazingly, everything he wrote in his last novel happened in real
          life!
        </p>
        <p style={{ width: '100%' }}>To be continued…</p>
        <br />
        <p style={{ width: '100%' }}>- George Martin’s</p>
      </BailetsBlock>

      <BailetsBlock>
        <h3
          style={{
            marginTop: '25px',
            textAlign: 'left',
            paddingLeft: '35px',
            paddingRight: '35px',
            boxSizing: 'border-box'
          }}
        >
          We were created by the divine words and the creation by the powerful
          and lightning words of a perfect King.
        </h3>
        <p style={{ width: '100%' }}>
          <span>By George Martin's</span>
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>We are</b> Writers
        </p>
        <br />
        <p style={{ width: '100%' }}>
          The amazing thing about words is that they can transform any
          situation!{' '}
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          They can drive the planet, and they can change the world! They can
          change us!
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Politicians persuade people with words…
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          A song is about words that touch the feelings of each listener, and
          make their souls fly to a planet of fantasy that is heaven for the
          dreamer.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Also, we can use “words” to define our behaviour in our day-to-day
          basics.
        </p>
        <p style={{ width: '100%' }}>…in fact,</p>
        <p style={{ width: '100%' }}>
          Writers can engage the social community at every level. They possess
          the skill of silent control with words.
        </p>
        <p style={{ width: '100%' }}>Why?</p>
        <p style={{ width: '100%' }}>
          because words drive the human brain and feel comfortable with it and
          generate stories over stories themselves. It’s like fire in the night
          that travels at light speed.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          We didn’t arrive on this planet through an evolution of other beings
          and took millions of years for humans to have the shape we have now.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Science tries to sell the story with scientific “words” to convince
          humanity of the nonsense of our past life.
        </p>
        <p style={{ width: '100%' }}>That’s a lie!</p>
        <p style={{ width: '100%' }}>
          The creation has no more than 6000 years and we arrived at this blue
          planet by the word of a Creator. Our Creator. By words.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Still today those “words” live inside of each human heart.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          If you stop for a second and try to dive inside yourself, you will
          listen to those words, that still live with us and give us life,
          forever.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>But,</p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          this new unknown generation doesn’t understand the meaning of the verb
          “to believe”.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          …and if we believe those words are internal life.
        </p>
        <p style={{ width: '100%' }}>
          Hey… STOP for a while. Listen. What’s the meaning of an unknown
          generation?
        </p>
        <p style={{ width: '100%' }}>
          An unknown generation is an exciting, fresh start! A material one, and
          a great one at that! A generation with the exciting opportunity to
          discover spirituality and their souls! They are living a fantastic,
          fake life! They live in a wonderful, magical illusion!
        </p>
        <p style={{ width: '100%' }}>
          They don’t believe what they should believe.
        </p>
        <p style={{ width: '100%' }}>Thinking deeply…</p>
        <p style={{ width: '100%' }}>What is the meaning of the word “word”?</p>
        <p style={{ width: '100%' }}>
          The word “word” has multiple meanings depending on the context:
        </p>
        <p style={{ width: '100%' }}>
          <b>1- Basic Meaning:</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          A single distinct unit of language that has meaning and can be spoken
          or written.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Example: “The sentence has five words.”
        </p>
        <p style={{ width: '100%' }}>
          <b>2- Linguistic Term:</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          A combination of letters that conveys a specific idea or concept in a
          language.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Example: “The word ‘love’ can be a noun or a verb.”
        </p>
        <p style={{ width: '100%' }}>
          <b>3- Promise or Assurance:</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Used to indicate a vow or guarantee.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Example: “I give you my word that I’ll be there.”
        </p>
        <p style={{ width: '100%' }}>
          <b>4- Expression or Phrase:</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Can refer to a saying, phrase, or notable statement.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Example: “She always has the right word for every situation.”
        </p>
        <p style={{ width: '100%' }}>
          <b>5- Command or Order:</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Refers to an instruction or directive.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Example: “We await the word from the commander.”
        </p>
        <p style={{ width: '100%' }}>
          <b>6- Slang (often used in conversation):</b>
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Used to express agreement or affirmation.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Example: “You’re coming to the party, right?” – “Word.”
        </p>
        <p style={{ width: '100%' }}>
          In a short definition, “word” can be a linguistic element, a promise,
          a command, or even an expression of agreement, depending on how it’s
          used!
        </p>
        <p style={{ width: '100%' }}>
          Words are the mystery of life that contains time and existence.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          What is time? What is existence?
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Time is the measure of a change and existence is the time womb.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          If time didn’t exist there wouldn’t be existence, and if existence
          didn’t exist there wouldn’t be time.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          It would be an emptiness without definition.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          But because of words, everything is possible.
        </p>
        <br />
        <p style={{ width: '100%' }}>- George Martin’s</p>
        <p style={{ width: '100%' }}>
          P.S. The movement of your lips is about words in a shelter of silence.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Use your “words” to create peace and not for the distraction of your
          world of “words”.
        </p>
      </BailetsBlock>
      <BailetsBlock>
        <h3
          style={{
            marginTop: '25px',
            textAlign: 'left',
            paddingLeft: '35px',
            paddingRight: '35px',
            boxSizing: 'border-box'
          }}
        >
          Are we living among killers?: Why Life Matters?
        </h3>
        <p style={{ width: '100%' }}>
          <span>By George Martin's</span>
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>We are</b> Copywriters
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Your mum is a goddess, and you're an assassin.</b>
        </p>
        <p style={{ width: '100%' }}>Someone needs to stop this madness!</p>
        <p style={{ width: '100%' }}>
          Not even the government is willing to discuss this. They are murderers
          too.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          I want to know what the difference is between a person who kills an
          adult and a person who kills a being inside a woman's womb.
        </p>
        <p style={{ width: '100%' }}>
          I refuse to identify the distinction. They are both KILLERS.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          I want to know which is more dangerous for society.
        </p>
        <p style={{ width: '100%' }}>Which society are you talking about?</p>
        <p style={{ width: '100%' }}>
          A society obsessed with pleasure, parties and murdering innocent
          beings who cannot protect themselves.
        </p>
        <p style={{ width: '100%' }}>
          Do you want to live in a culture where even doctors can kill little
          ones for money?{' '}
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>I don't think so.</p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Abortion is undoubtedly one of the most polarising issues in society
          today. It touches on the core values of life, morality and human
          dignity. There is no question about it.
        </p>
        <p style={{ width: '100%' }}>
          I want to know where these women's so-called values are when it comes
          to defending life.
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          While the debate is often framed in terms of personal choice, we must
          consider the profound implications of terminating an unborn life
          without hesitation.
        </p>
        <p style={{ width: '100%' }}>
          <b>Children are “happiness”.</b>
        </p>
        <p style={{ width: '100%', marginTop: '7px' }}>
          <b>Babies are heaven.</b>
        </p>
        <p style={{ width: '100%' }}>
          The pro-life stance is based on the irrefutable fact that life begins
          at conception. From fertilisation, a new human life with its unique
          DNA is created. This is not a matter of opinion.
        </p>
        <p style={{ width: '100%' }}>It is a scientific fact.</p>
        <p style={{ width: '100%' }}>
          We must acknowledge this and protect and defend the most vulnerable
          among us – those who cannot speak for themselves.
        </p>
        <p style={{ width: '100%' }}>
          "For you, lady - a 0-week-old baby in your womb is a human being full
          of life. You are the bearer of life for our generation."
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Tell me, what are your thoughts about the madness this world is going
          through?
        </p>
        <p style={{ width: '100%' }}>
          Because I have no answer to this question.
        </p>
        <p style={{ width: '100%' }}>
          “<b>Jesus said:</b> Let the little children come to Me, and do not
          forbid them; for of such is the kingdom of heaven.” Matthew 19:14
        </p>
        <p style={{ width: '100%' }}>
          If the little ones are the kingdom of heaven,
        </p>
        <p style={{ width: '100%', marginTop: '10px' }}>
          Why does our civilisation insist on destroying the beauty of paradise?
        </p>
        <p style={{ width: '100%' }}>We’re living in the end of times!</p>
        <p style={{ width: '100%' }}>– George Martin’s</p>
      </BailetsBlock>

      <BailetsBlock>
        <h3
          style={{
            marginTop: '25px',
            textAlign: 'left',
            paddingLeft: '35px',
            paddingRight: '35px',
            boxSizing: 'border-box'
          }}
        >
          Would you work with me? I would love to write something for you.
        </h3>
        <p style={{ width: '100%' }}>
          <span>By George Martin's</span>
        </p>
        <br />
        <p style={{ width: '100%' }}>{`Hello {%name%},`}</p>
        <br />
        <p style={{ width: '100%' }}>
          I'm George Martin's, a freelance copywriter. I can help make your
          brand a success. And it smells as good as it is, with EXCELLENCE
          oozing out of every word.
        </p>
        <p style={{ width: '100%' }}>You might THINK I’m bluffing.</p>
        <br />
        <p style={{ width: '100%' }}>
          <b>I know.</b>
        </p>
        <br />
        <p style={{ width: '100%' }}>
          You worked with many copywriters before who told you the same thing
        </p>
        <p style={{ width: '100%', marginTop: 0 }}>
          "I'm the best. I can make your tone of voice the leader of the market.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>…But you can try one more writer.</b>
        </p>
        <br />
        <p style={{ width: '100%' }}>
          This could be your lucky day! You might get the most high-level boom
          your brand has ever seen.
        </p>
        <br />
        <p style={{ width: '100%' }}>…but today.</p>
        <br />
        <p style={{ width: '100%' }}>
          I would like to tell you about something more important.
        </p>
        <p style={{ width: '100%', marginTop: 0 }}>
          Bailey needed to do some medical exams. Doctors say he may have
          epilepsy… a bit sad!
        </p>
        <p style={{ width: '100%', marginTop: 0 }}>
          You must be wondering who Bailey is and what you have to do with him.
        </p>
        <p style={{ width: '100%' }}>
          He is my dog. He is a Labrador, 22 months old. He’s too young to have
          a disease like this. Yesterday he lost consciousness, lying on the
          floor and shaking everywhere.
        </p>
        <p style={{ width: '100%', marginTop: 0 }}>
          He couldn't get up, he struggled to walk.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          He taught me how to be a better writer and human being…
        </p>
        <br />
        <p style={{ width: '100%' }}>
          Yes, Bailey is my best friend, and <b>JESUS</b> is my inspiration. He
          gave me the gift of life and helped me move forward when I reached the
          point of giving up.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          …But my clients are part of my inspiration too and you’re one of them.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>You got me inspired…</b>
        </p>
        <br />
        <p style={{ width: '100%' }}>
          I guarantee you'll have the best writing journey of your life.{' '}
        </p>
        <p style={{ width: '100%', marginTop: 0 }}>
          I can't promise you a 50% increase in sales, but you'll see a 35%
          improvement at the very least.{' '}
        </p>
        <br />
        <p style={{ width: '100%' }}>
          Sign up for my newsletter and get an <b>amazing 70% discount</b> if
          you start working with me today!
        </p>
        <br />
        <p style={{ width: '100%' }}>So… What do you think?</p>
        <br />
        <p style={{ width: '100%' }}>Here’s my website. Let’s talk.</p>
        <p style={{ width: '100%', marginTop: 0 }}>
          <a
            href="http://www.jorgedd.com"
            target="_blank"
            style={{ textDecoration: 'underline', color: 'blue' }}
          >
            www.jorgedd.com
          </a>
        </p>
        <br />
        <p style={{ width: '100%' }}>- George Martin's</p>
        <br />
        <p style={{ width: '100%' }}>
          P.S. Don’t worry, Bailey is fine. Next week he will go to the Doctor
          again.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h3
          style={{
            marginTop: '25px',
            textAlign: 'left',
            paddingLeft: '35px',
            paddingRight: '35px',
            boxSizing: 'border-box'
          }}
        >
          Your business will expand if you make a quick decision.
        </h3>
        <p style={{ width: '100%' }}>
          <span>By George Martin's</span>
        </p>
        <br />
        <p style={{ width: '100%' }}>{`Hi {%name%},`}</p>
        <br />
        <p style={{ width: '100%' }}>
          Still interested in making your business grow?
        </p>
        <p style={{ width: '100%' }}>
          Words are the key to wealth and the gateway to a radiant future! If
          you don't decide to move forward, someone else will!
        </p>
        <p style={{ width: '100%' }}>
          Be one step ahead of everyone else! You'll be the first to catch the
          train to the oceans of new clients.
        </p>
        <p style={{ width: '100%' }}>Today, was a wonderful day.</p>
        <p style={{ width: '100%' }}>
          I landed one more client asking me to create their copywriting
          project. They want to reach top clients.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          You can be my next successful client. I would like to make your brand
          shine shortly.
        </p>
        <br />
        <p style={{ width: '100%' }}>Let’s work together.</p>
        <br />
        <p style={{ width: '100%' }}>- George Martin's</p>
        <br />
        <p style={{ width: '100%' }}>
          P.S. Don’t worry, Bailey is fine. Next week he will go to the Doctor
          again.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h3
          style={{
            marginTop: '25px',
            textAlign: 'left',
            paddingLeft: '35px',
            paddingRight: '35px',
            boxSizing: 'border-box'
          }}
        >
          Do you believe in yourself? You shouldn’t! Society is lying to you.
        </h3>
        <p style={{ width: '100%' }}>
          <span>By George Martin's</span>
        </p>
        <br />
        <p style={{ width: '100%' }}>
          That's right. I would go so far as to say…
        </p>
        <p style={{ width: '100%', marginTop: 0 }}>
          Don't put your faith solely in yourself.
        </p>
        <p style={{ width: '100%' }}>
          Society relentlessly promotes the mantra "Believe in yourself," but
          that’s a misconception.
        </p>
        <p style={{ width: '100%' }}>
          There are countless incredible strategies to elevate your brand using
          a voice that resonates with you! Copywriting can effectively capture
          your core beliefs and outline the necessary steps to achieve your
          goals.
        </p>
        <p style={{ width: '100%' }}>
          I understand your challenges. Why is that?
        </p>
        <p style={{ width: '100%' }}>Because…</p>
        <p style={{ width: '100%' }}>
          You require compelling copy and content for your products, blog,
          website, and marketing campaigns. You're poised to elevate your sales
          and become a remarkable success!
        </p>
        <p style={{ width: '100%' }}>
          I genuinely care about you, <b>{`{%name%}`}</b>. You possess the
          potential to excel in your field.
        </p>
        <p style={{ width: '100%' }}>
          I'm here to support you and thrilled to collaborate on developing the
          brand voice you’ve always envisioned.
        </p>
        <p style={{ width: '100%' }}>
          What are the genuine beliefs? There’s one belief that can guide you to
          a wondrous place where everything you touch turns to gold.
        </p>
        <p style={{ width: '100%' }}>
          <b>JESUS.</b>
        </p>
        <p style={{ width: '100%' }}>
          Place your faith in Him rather than in yourself
        </p>
        <p style={{ width: '100%' }}>
          We cannot transform the world or even ourselves. If you're unwell,
          believing in yourself won’t heal or alleviate your pain and sorrow.
        </p>
        <p style={{ width: '100%' }}>
          But Jesus can. He is our healer and creator.
        </p>
        <p style={{ width: '100%', marginTop: 0 }}>
          He understands us more profoundly than we do ourselves.
        </p>
        <p style={{ width: '100%' }}>
          If you rely solely on self-belief, you risk undermining your brand.
          You need a source of strength, and that source is your creator.
        </p>
        <p style={{ width: '100%' }}>
          You may need reassurance about my confidence, but I can guarantee it’s
          unwavering!
        </p>
        <p style={{ width: '100%' }}>So… what do you think?</p>
        <br />
        <p style={{ width: '100%' }}>— George Martin’s</p>
        <p style={{ width: '100%' }}>
          P.S. Also, Don’t be shy! Book a call with me, and your brand will have
          the best writing ever.{' '}
        </p>
        <p style={{ width: '100%', marginTop: 0 }}>
          Click{' '}
          <a
            href="https://calendly.com/georgedmartins/30min"
            target="_blank"
            style={{ textDecoration: 'underline', color: 'blue' }}
          >
            here
          </a>{' '}
          to book a call with me.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h3
          style={{
            marginTop: '25px',
            textAlign: 'left',
            paddingLeft: '35px',
            paddingRight: '35px',
            boxSizing: 'border-box'
          }}
        >
          I got 3 new clients, this week. But you’re my favourite.
        </h3>
        <p style={{ width: '100%' }}>
          <span>By George Martin's</span>
        </p>
        <br />
        <p style={{ width: '100%' }}>You know {`{%name%}`},</p>
        <p style={{ width: '100%' }}>
          It’s amazing how life sometimes surprises and guides us for the best.
          To new paths. To new worlds that we couldn’t imagine to get there so
          fast.
        </p>
        <p style={{ width: '100%' }}>
          <b>This week…</b>
        </p>
        <p style={{ width: '100%' }}>
          I signed a contract with three new clients. I was hoping one of them
          was you. I was already planning your new life, blooming in my head…
        </p>
        <p style={{ width: '100%', marginTop: '7px' }}>
          But none of them was your brand…
        </p>
        <p style={{ width: '100%' }}>
          Do you need more time to think about your new Copywriting project?
        </p>
        <p style={{ width: '100%' }}>That’s ok.</p>
        <p style={{ width: '100%' }}>
          <b>Take your time.</b>
        </p>
        <p style={{ width: '100%' }}>
          I’ll always be here to help you to achieve the goals you have in your
          mind for your brand, {`{%name%}`}
        </p>
        <p style={{ width: '100%' }}>
          Together, we’ll blow up your brand market niche with success.
        </p>
        <p style={{ width: '100%' }}>
          TALK TO ME about anything that is in your thoughts now. Anything!
        </p>
        <br />
        <p style={{ width: '100%' }}>- George Martin's</p>
        <p style={{ width: '100%' }}>
          P.S. <b>You are my favourite.</b> I know you have EVERYTHING to be the
          first in your industry.
        </p>
        <p style={{ width: '100%' }}>
          <b>YOU GOT THIS!</b>
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h3
          style={{
            marginTop: '25px',
            textAlign: 'left',
            paddingLeft: '35px',
            paddingRight: '35px',
            boxSizing: 'border-box'
          }}
        >
          Something special for you. Be the first to get it!
        </h3>
        <p style={{ width: '100%' }}>
          <span>By George Martin's</span>
        </p>
        <br />
        <p style={{ width: '100%' }}>You’re right {`{%name%}`},</p>
        <p style={{ width: '100%' }}>
          The world is full of options out there. That’s true! The choice you
          make for the future is not limited. It grows every single day.
        </p>
        <p style={{ width: '100%' }}>
          …but how will be the next generation, market?
        </p>
        <p style={{ width: '100%' }}>
          Life is unpredictable. You have less time to think about opportunities
          like this one.
        </p>
        <p style={{ width: '100%' }}>Yes...</p>
        <p style={{ width: '100%', marginTop: '7px' }}>
          You know what? Everything happens for a reason! And I'm writing to you
          for that very reason.
        </p>
        <p style={{ width: '100%' }}>I got something special for you…</p>
        <p style={{ width: '100%', marginTop: '7px' }}>
          You don’t need to be my client to get my offers.
        </p>
        <p style={{ width: '100%' }}>
          I'm so excited to help you succeed and want to see you become a
          well-established brand with a roster of top clients in your industry.
        </p>
        <p style={{ width: '100%' }}>
          So, be the first to get this amazing E-book, written for you.
        </p>
        <p style={{ width: '100%', marginTop: '7px' }}>
          <a href="#" style={{ textDecoration: 'underline', color: 'blue' }}>
            30% off Email Marketing kit, with 10 emails that will help you to
            reach new top clients
          </a>
        </p>
        <p style={{ width: '100%' }}>
          <b>Don’t miss out.</b>
        </p>
        <p style={{ width: '100%' }}>
          You can use these emails and update them with your terms.
        </p>
        <p style={{ width: '100%', marginTop: '7px' }}>
          Use them well to grow your business.
        </p>
        <p style={{ width: '100%' }}>Why?</p>
        <p style={{ width: '100%' }}>Because you work hard and deserve it.</p>
        <p style={{ width: '100%' }}>You’re still my favourite,</p>
        <br />
        <p style={{ width: '100%' }}>– George Martin’s</p>
        <p style={{ width: '100%' }}>
          P.S. I almost forgot - This offer is valid for only 5 days. Get your
          free e-book and offers.
        </p>
        <p style={{ width: '100%' }}>You’ll be the winner!</p>
      </BailetsBlock>

      <BailetsBlock>
        <h3
          style={{
            marginTop: '25px',
            textAlign: 'left',
            paddingLeft: '35px',
            paddingRight: '35px',
            boxSizing: 'border-box'
          }}
        >
          That’s it. The final step! You still have time to get your offer
        </h3>
        <p style={{ width: '100%' }}>
          <span>By George Martin's</span>
        </p>
        <br />
        <p style={{ width: '100%' }}>This is it.</p>
        <p style={{ width: '100%' }}>
          I did everything I could to help you reach more top clients, you
          always dream about and want to work for.
        </p>
        <p style={{ width: '100%', marginTop: '7px' }}>
          Nothing would be more important than to grow your business straight to
          happy days!{' '}
        </p>
        <p style={{ width: '100%' }}>
          Words have the power to transform lives and businesses.
        </p>
        <p style={{ width: '100%' }}>
          And I would be very HAPPY to see one of my top clients grow with a
          great copy. But you decided not to dare to take the next step. 🙁
        </p>
        <p style={{ width: '100%' }}>I know {`{%name%}`},</p>
        <p style={{ width: '100%' }}>
          Sometimes we’re pretty APPREHENSIVE to move forward. And it’s nice to
          be in our comfort zone. But that zone is the worst enemy to be
          successful.
        </p>
        <p style={{ width: '100%' }}>
          You need to get out of that place, where you’ll get nothing but to be
          anxious and dream without coming out of the box.
        </p>
        <p style={{ width: '100%' }}>
          Before I started my freelance business, I was on the same road that
          you are now, overthinking a new future perspective. But nothing moved
          forward till I decided to start and kicked out to an amazing life
          ahead.
        </p>
        <p style={{ width: '100%' }}>Don’t rely on the same mistake I did.</p>
        <p style={{ width: '100%' }}>Why not stop overthinking?</p>
        <p style={{ width: '100%' }}>
          STOP once and for all and come out of your comfort zone. Get confident
          in your powers. Fulfill your dream of being a top brand. Believe in
          the one above all and everything. <b>GOD!</b>
        </p>
        <p style={{ width: '100%' }}>
          <b>I will always be here to help you.</b> 🙂
        </p>
        <p style={{ width: '100%' }}>
          You still have time to get my{' '}
          <a href="#" style={{ textDecoration: 'underline', color: 'blue' }}>
            30% off email marketing e-book
          </a>{' '}
          to restructure your confidence and be proud of yourself.
        </p>
        <p style={{ width: '100%' }}>
          <b>
            This offer ends this week.{' '}
            <a href="#" style={{ textDecoration: 'underline', color: 'blue' }}>
              So download it now.
            </a>
          </b>
        </p>
        <p style={{ width: '100%' }}>
          You also get 50% off my new{' '}
          <a href="#" style={{ textDecoration: 'underline', color: 'blue' }}>
            Email marketing and LinkedIn posts E-book, now available for only
            £220
          </a>
          .
        </p>
        <p style={{ width: '100%' }}>
          <b>Enjoy the offer.</b>
        </p>
        <p style={{ width: '100%' }}>I can’t wait to see you happy!</p>
        <br />
        <p style={{ width: '100%' }}>– George Martin’s</p>
        <p style={{ width: '100%' }}>
          P.S. This is the final email I’m sending about my offers. But it’s not
          the end.
        </p>
        <p style={{ width: '100%', marginTop: '7px' }}>
          My next copy generation will blow your mind.
        </p>
      </BailetsBlock>
    </>
  );
};
